<template>
    <ErrorPage>
        <template slot="Title">
            Something is missing!
        </template>
        <template slot="SubTitle">
            Before creating a clock, you will need:
        </template>
        <template slot="Content">
            <div class="helper-container">
                <RequiredActionItem>
                    <template>
                        <span>A <a href='#' @click="$router.push({name:'BoxList', params:{boxType:'MUSIC'}});">music box</a> including your music files</span>
                    </template>
                </RequiredActionItem>
            </div>
        </template>
        <template slot="Actions">
            <Button :empty="true" @click="$router.push({name:'BoxList', params:{boxType:'MUSIC'}});">Back to music boxes</Button>
        </template>
    </ErrorPage>
</template>

<script>
    import router from '@/router'

    import RequiredActionItem from'@/components/common/RequiredActionItem.vue'   
    import Button from'@/components/common/Button.vue'
    import ErrorPage from'@/components/common/ErrorPage.vue'
    export default {
        name: "ClockStuckedCard",
        router,
        components: {
            Button, RequiredActionItem, ErrorPage
        },
        methods: {
        }
    }
</script>

<style scoped>
</style>